import React from 'react'
import styled from "styled-components"
import media from "styled-media-query"

const SelectSchool = ({school, setSchool}) => {

   let schoolTitle
   if (school === "hs") {
      schoolTitle = "高校生"
   } else if (school === "jhs") {
      schoolTitle = "中学生"
   } else if (school === "es") {
      schoolTitle = "小学生"
   }


   return (
      <SSStyles school={school}>
         <div className="btns">
            <button 
               className="hs"
               onClick={() => setSchool("hs")}
            >
               高校生
            </button>

            <button 
               className="jhs"
               onClick={() => setSchool("jhs")}
            >
               中学生
            </button>

            <button 
               className="es"
               onClick={() => setSchool("es")}
            >
               小学生
            </button>
         </div>
         <div className="bar"/>
         <h3 className="school">
            {schoolTitle}
         </h3>
      </SSStyles>
   )
}

const SSStyles = styled.div`

   width: 100%;
   display: flex;
   flex-direction: column;
   .btns {
      width: 100%;
      display: flex;
      button {
         display: block;
         width: calc(100% / 3);
         height: 68px;
         padding: 0;
         border: 0;
         background-color: #fff;
         color: #FF3D01;
         border-radius: 10px 10px 0 0;
         box-shadow: 0 -1px 6px #000;
         transition: 0.2s;
         font-size: 2.2rem;
         ${media.lessThan("960px")`
            height: 58px;
            font-size: 1.8rem;
         `}
         ${media.lessThan("600px")`
            height: 48px;
            font-size: 1.6rem;
         `}
         &:hover {
            cursor: pointer;
            background-color: #FF3D01;
            color: #fff;
         }
      }
      .hs {
         background-color: ${({school}) => school === "hs" ? "#FF3D01" : "#fff"};
         color: ${({school}) => school === "hs" ? "#fff" : "#FF3D01"};
      }
      .jhs {
         background-color: ${({school}) => school === "jhs" ? "#FF3D01" : "#fff"};
         color: ${({school}) => school === "jhs" ? "#fff" : "#FF3D01"};
      }
      .es {
         background-color: ${({school}) => school === "es" ? "#FF3D01" : "#fff"};
         color: ${({school}) => school === "es" ? "#fff" : "#FF3D01"};
      }
   }


   .bar{
      width: 100%;
      height: 14px;
      background-color: #FF3D01;
      ${media.lessThan("960px")`
         height: 11px;
      `}
      ${media.lessThan("600px")`
         height: 7px;
      `}
   }
   .school {
      margin-top: 50px;
      font-size: 3.8rem;
      text-align: center;
      color: #FF3D01;
      ${media.lessThan("960px")`
         font-size: 3.2rem;
      `}
      ${media.lessThan("600px")`
         font-size: 2.4rem;
      `}
   }
`

export default SelectSchool